module.exports = __webpack_public_path__ + "static/img/newsc.c45883b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/newsc.png
// module id = Vfd9
// module chunks = 45